import axios from 'axios';
import {messageService } from './services/subscriberService';
import { env, CheckValue } from './services/CommonFunction';
import { staticVar } from './services/Constants';
import { unregister } from './serviceWorkerRegistration';

const instance = axios.create({
    baseURL : env('Urls')
});

instance.interceptors.request.use(request => {
    if(messageService.show) {
        messageService.sendMessage(true);
    } else {
        messageService.show = true;
    }
    let token = localStorage.getItem('accessToken');
    if (token)  {
        request.headers.access_token = token;
    }
    if(CheckValue(staticVar.app_id)) {
        request.headers.app_id = staticVar.app_id;
    }
    // temp['app_id'] = userData.selectedGym.app_id;
    if(request.url === 'v1/member/app-versions') {
        // const data = JSON.parse(request.data);
        if(CheckValue(request.data.app_id)) {
            request.headers.app_id = request.data.app_id;
        }
    }
    return request ;
},
error => {
    console.error(error);
    messageService.sendMessage(false);
    return Promise.reject(error);
});

instance.interceptors.response.use(response => {
    if(response.headers['latest-coach-panel'] === 'false' ) {
        if(!CheckValue(localStorage.getItem('latest-coach-panel'))) {
            localStorage.setItem('latest-coach-panel','false');
            unregister();
        }
    }
    messageService.sendMessage(false);
    return response ;
},
error => {
    messageService.sendMessage(false);
    return Promise.reject(error);
});

instance.defaults.headers.common['content-language'] = 'en';

export default instance;